import script from "./footerZz.vue?vue&type=script&setup=true&lang=js"
export * from "./footerZz.vue?vue&type=script&setup=true&lang=js"

import "./footerZz.vue?vue&type=style&index=0&id=bead3692&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.18_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bead3692"]])

export default __exports__